import { type ReactElement, type SVGProps } from 'react';

export const BedroomPropertyIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24" {...props}>
      <path fill="currentColor" d="M19 3H5v6H3v12h1v-2.996h16V21h1V9h-2V3ZM6 4h12v5h-2V6H8v3H6V4Zm9 5H9V7h6v2Zm5 1v7.004H4V10h16Z" />
    </svg>
  );
};
